import { FC, useCallback } from 'react';
import styled from 'styled-components';

import { useDownloadAppModal } from '@hooks/useDownloadAppModal';
import { useChannelDataById } from '@redux/selectors/channels';
import theme from 'theme';
import { PremierText } from '@components/text/Text';
import TouchableOpacity from '@components/buttons/TouchableOpacity';
import Image from '@components/image';

const Container = styled(TouchableOpacity)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: row;
    gap: 4px;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ChannelImage = styled(Image)`
  width: 56px;
  height: 56px;
  box-shadow: 2px 2px 4px 0 ${theme.colors.black}${theme.opacity[40]};
  border: 0.5px solid ${theme.colors.grey[700]};

  @media (max-width: ${theme.breakpoints.md}) {
    width: 40px;
    height: 40px;
  }
`;

const Name = styled(PremierText)`
  max-width: 120px;
  display: -webkit-box;
  color: ${({ theme }) => theme.colors.white};
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    max-width: 100%;
    -webkit-line-clamp: 1;
  }
`;

type Props = {
  channelId: string;
};

const ChannelView: FC<Props> = ({ channelId }) => {
  const channel = useChannelDataById(channelId);

  const { openDownloadAppModal } = useDownloadAppModal();

  const onChannelClick = useCallback(() => {
    openDownloadAppModal();
  }, [openDownloadAppModal]);

  if (!channel) {
    return null;
  }

  return (
    <Container onClick={onChannelClick}>
      <ImageWrapper>
        <ChannelImage src={channel.image} alt={channel.name} />
      </ImageWrapper>

      <Name>{channel.name || ''}</Name>
    </Container>
  );
};

export default ChannelView;
